/**
 * 関連会社ユーザ情報サービス
 */
export class KYMW9000InputVO {
    // ユーザ区分
    public associatedUserType: string = <string>'';

    // 氏名
    public associatedUserName: string = <string>'';

    // メールアドレス
    public emailAddress: string = <string>'';

    // 権限セットID
    public authoritySetId: string = <string>'';

    // 所属名（関連会社名 or 取引先名）
    public associatedCompanyName: string = <string>'';

    // 有効/無効区分
    public isEnabled: string = <string>'';

    // ページ番号
    public page: number = 0;
}